import { useCallback, useMemo } from 'react';

import * as events from 'src/lib/events';
import { PAGES, SUB_PAGES, useTrackingEvent } from 'src/services';
import { useCurrentProjectId } from 'src/store';

const useGetProjectAttributes = () => {
  const projectId = useCurrentProjectId();
  return useCallback(
    () => ({
      projectId,
    }),
    [projectId]
  );
};

export const useEvents = (generationTool) => {
  const trackingEvent = useTrackingEvent();
  const getProjectAttributes = useGetProjectAttributes();

  const trackClickedToneOfVoice = useCallback(() => {
    trackingEvent(events.DOCUMENT.clickedToneOfVoice, {
      ...getProjectAttributes(),
      generationTool,
      page: PAGES.editor,
      subPage: SUB_PAGES.generationPanel,
    });
  }, [trackingEvent, getProjectAttributes, generationTool]);

  const trackClickedCreateToneOfVoice = useCallback(() => {
    trackingEvent(events.DOCUMENT.clickedCreateNewToneOfVoice, {
      ...getProjectAttributes(),
      generationTool,
      page: PAGES.editor,
      subPage: SUB_PAGES.generationPanel,
    });
  }, [trackingEvent, getProjectAttributes, generationTool]);

  return useMemo(
    () => ({
      trackClickedToneOfVoice,
      trackClickedCreateToneOfVoice,
    }),
    [trackClickedToneOfVoice, trackClickedCreateToneOfVoice]
  );
};
